module.exports = __webpack_public_path__ + "static/media/clotheSurvey.c3a3b8ae.jpg";